export const faqCarrefour = [

    {
        empresa: "evino",
        categorias: [
            {
                nome: "cadastro",
                perguntas: [
                    {
                        pergunta: "O cliente precisa realizar algum cadastro?",
                        resposta: "Sim"
                    },

                    {
                        pergunta: "Onde o cadastro deve ser realizado?",
                        resposta: "No site do parceiro: https://www.evino.com.br"
                    }
                ]
            },

            {
                nome: "Desconto",
                perguntas: [
                    {
                        pergunta: "Como faço para aplicar o desconto?",
                        resposta: 'Use o cupom CARREFOUR30 e ganhe R$30 off em compras acima de R$150  ou  use o cupom CARREFOUR20 e ganhe R$20 off em compras acima de R$200'
                    },
                    {
                        pergunta: "Existe compra mínima?",
                        resposta: "R$ 150,00 OU R$ 200,00 depende do cupom a ser aplicado."
                    },
                    {
                        pergunta: "Posso utilizar o cupom em todas as categorias?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "O frete está incluso?",
                        resposta: "Não"
                    },
                    {
                        pergunta: "Posso utilizar o desconto mais de uma vez?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "O cupom não está funcionando, como proceder?",
                        resposta: "Utilize o chat na pagina do parceiro https://www.evino.com.br ou pelo SAC (11)4200-4999"
                    },
                ]
            },
            {
                nome: "Pagamento",
                perguntas: [
                    {
                        pergunta: "Só posso pagar com o cartão Carrefour?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "Posso parcelar o pagamento?",
                        resposta: "Verificar as condiçoes no carrinho"
                    },
                ]
            },
        ]
    },
    {
        empresa: "Gocase",
        categorias: [
            {
                nome: "Cadastro",
                perguntas: [
                    {
                        pergunta: "O cliente precisa realizar algum cadastro?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "Onde o cadastro deve ser realizado?",
                        resposta: "No site do parceiro: https://www.gocase.com.br"
                    },
                ]
            },
            {
                nome: "Desconto",
                perguntas: [
                    {
                        pergunta: "Como faço para aplicar o desconto?",
                        resposta: "Use o cupom <b>CARREFOUR10</b> e ganhe 10% off em todo o site."
                    },
                    {
                        pergunta: "Existe compra mínima?",
                        resposta: "Não"
                    },
                    {
                        pergunta: "Posso utilizar o cupom em todas as categorias?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "O frete está incluso?",
                        resposta: "Não"
                    },
                    {
                        pergunta: "Posso utilizar o desconto mais de uma vez?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "O cupom não está funcionando, como proceder?",
                        resposta: "Acesso o suporte da GoCase: https://suporte.gocase.com.br/hc/pt-br"
                    },
                ]
            },
            {
                nome: "Pagamento",
                perguntas: [
                    {
                        pergunta: "Só posso pagar com o cartão Carrefour?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "Posso parcelar o pagamento?",
                        resposta: "Verificar as condiçoes no carrinho"
                    },
                ]
            },
        ]
    },
    {
        empresa: "Unidas Aluguel de carros",
        categorias: [
            {
                nome: "Cadastro",
                perguntas: [
                    {
                        pergunta: "O cliente precisa realizar algum cadastro?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "Onde o cadastro deve ser realizado?",
                        resposta: "No site do parceiro: https://www.unidas.com.br/parceiro/ParceriaCartaocarrefour"
                    },
                ]
            },
            {
                nome: "Desconto",
                perguntas: [
                    {
                        pergunta: "Como faço para aplicar o desconto?",
                        resposta: "O desconto será aplicado automáticamente no carrinho. O percentual varia de acordo com a campanha vigente."
                    },
                    {
                        pergunta: "Existe compra mínima?",
                        resposta: "Não"
                    },
                    {
                        pergunta: "Posso utilizar o cupom em todas as categorias?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "O frete está incluso?",
                        resposta: "Não"
                    },
                    {
                        pergunta: "Posso utilizar o desconto mais de uma vez?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "O cupom não está funcionando, como proceder?",
                        resposta: "Utilize Serviço de Atendimento ao Cliente da Unidas: <b>0800 771 5158</b>"
                    },
                ]
            },
            {
                nome: "Pagamento",
                perguntas: [
                    {
                        pergunta: "Só posso pagar com o cartão Carrefour?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "Posso parcelar o pagamento?",
                        resposta: "Verificar as condiçoes no carrinho"
                    },
                ]
            },

        ]
    },
    {
        empresa: "Maria Brasileira",
        categorias: [
            {
                nome: "Cadastro",
                perguntas: [
                    {
                        pergunta: "O cliente precisa realizar algum cadastro?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "Onde o cadastro deve ser realizado?",
                        resposta: "No site do parceiro: https://mariabrasileira.com.br/"
                    },
                ]
            },
            {
                nome: "Desconto",
                perguntas: [
                    {
                        pergunta: "Como faço para aplicar o desconto?",
                        resposta: "Ganhe R$15 OFF na contratação de qualquer serviço de limpeza ou passadeira. Desconto será aplicado após inserir os dados do Cartão Carrefour."
                    },
                    {
                        pergunta: "Existe compra mínima?",
                        resposta: "Não"
                    },
                    {
                        pergunta: "Posso utilizar o cupom em todas as categorias?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "O frete está incluso?",
                        resposta: "Não"
                    },
                    {
                        pergunta: "Posso utilizar o desconto mais de uma vez?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "O cupom não está funcionando, como proceder?",
                        resposta: "Utilize o suporte a dúvidas: https://mariabrasileira.com.br/duvidas"
                    },
                ]
            },
            {
                nome: "Pagamento",
                perguntas: [
                    {
                        pergunta: "Só posso pagar com o cartão Carrefour?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "Posso parcelar o pagamento?",
                        resposta: "Verificar as condiçoes no carrinho"
                    },
                ]
            },

        ]
    },
    {
        empresa: "Unidas Livre",
        categorias: [
            {
                nome: "Cadastro",
                perguntas: [
                    {
                        pergunta: "O cliente precisa realizar algum cadastro?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "Onde o cadastro deve ser realizado?",
                        resposta: "No site do parceiro: https://www.vemserlivre.com.br/parceria/cartaocarrefour/"
                    },
                ]
            },
            {
                nome: "Desconto",
                perguntas: [
                    {
                        pergunta: "Como faço para aplicar o desconto?",
                        resposta: "30% OFF nas 8 primeiras parcelas no plano de 48 meses de um carro por assinatura. Desconto aplicado automáticamente no carrinho."
                    },
                    {
                        pergunta: "Existe compra mínima?",
                        resposta: "Sim, plano de 48 meses"
                    },
                    {
                        pergunta: "Posso utilizar o cupom em todas as categorias?",
                        resposta: "Somente no plano de 48 meses"
                    },
                    {
                        pergunta: "O frete está incluso?",
                        resposta: "Não"
                    },
                    {
                        pergunta: "Posso utilizar o desconto mais de uma vez?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "O cupom não está funcionando, como proceder?",
                        resposta: "Utilize o suporte a dúvidas: https://www.vemserlivre.com.br/parceria/cartaocarrefour"
                    },
                ]
            },
            {
                nome: "Pagamento",
                perguntas: [
                    {
                        pergunta: "Só posso pagar com o cartão Carrefour?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "Posso parcelar o pagamento?",
                        resposta: "Verificar as condiçoes no carrinho"
                    },
                ]
            },

        ]
    },
    {
        empresa: "Cacau Show",
        categorias: [
            {
                nome: "Cadastro",
                perguntas: [
                    {
                        pergunta: "O cliente precisa realizar algum cadastro?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "Onde o cadastro deve ser realizado?",
                        resposta: "No site do parceiro: https://www.cacaushow.com.br"
                    },
                ]
            },
            {
                nome: "Desconto",
                perguntas: [
                    {
                        pergunta: "Como faço para aplicar o desconto?",
                        resposta: "Use o cupom CARREFOUR10 e ganhe 10% de desconto nas compras online acima de R$99."
                    },
                    {
                        pergunta: "Existe compra mínima?",
                        resposta: "Sim, R$ 99,00"
                    },
                    {
                        pergunta: "Posso utilizar o cupom em todas as categorias?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "O frete está incluso?",
                        resposta: "Não"
                    },
                    {
                        pergunta: "Posso utilizar o desconto mais de uma vez?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "O cupom não está funcionando, como proceder?",
                        resposta: "Utilize o suporte on line: https://lovers.cacaushow.com.br/ajuda/cacaulovers%23atendimento"
                    },
                ]
            },
            {
                nome: "Pagamento",
                perguntas: [
                    {
                        pergunta: "Só posso pagar com o cartão Carrefour?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "Posso parcelar o pagamento?",
                        resposta: "Verificar as condiçoes no carrinho"
                    },
                ]
            },

        ]
    },
    {
        empresa: "Doutor Consulta",
        categorias: [
            {
                nome: "Cadastro",
                perguntas: [
                    {
                        pergunta: "O cliente precisa realizar algum cadastro?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "Onde o cadastro deve ser realizado?",
                        resposta: "No site do parceiro: https://yalo.com.br/familiacarrefour"
                    },
                ]
            },
            {
                nome: "Desconto",
                perguntas: [
                    {
                        pergunta: "Como faço para aplicar o desconto?",
                        resposta: "Ganhe 10% off na assinatura do dr.consulta, o Yalo Família. Desconto já aplicado no carrinho."
                    },
                    {
                        pergunta: "Existe compra mínima?",
                        resposta: "Não"
                    },
                    {
                        pergunta: "Posso utilizar o cupom em todas as categorias?",
                        resposta: "Não, somente no plano Yalo Família."
                    },
                    {
                        pergunta: "O frete está incluso?",
                        resposta: "Não"
                    },
                    {
                        pergunta: "Posso utilizar o desconto mais de uma vez?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "O cupom não está funcionando, como proceder?",
                        resposta: "FALE CONOSCO: contato@yalo.com.br | 0800 591 0697"
                    },
                ]
            },
            {
                nome: "Pagamento",
                perguntas: [
                    {
                        pergunta: "Só posso pagar com o cartão Carrefour?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "Posso parcelar o pagamento?",
                        resposta: "Verificar as condiçoes no carrinho"
                    },
                ]
            },

        ]
    },

]

export const faqAtacadao = [

    {
        empresa: "evino",
        categorias: [
            {
                nome: "cadastro",
                perguntas: [
                    {
                        pergunta: "O cliente precisa realizar algum cadastro?",
                        resposta: "Sim"
                    },

                    {
                        pergunta: "Onde o cadastro deve ser realizado?",
                        resposta: "No site do parceiro: https://www.evino.com.br"
                    }
                ]
            },

            {
                nome: "Desconto",
                perguntas: [
                    {
                        pergunta: "Como faço para aplicar o desconto?",
                        resposta: 'Use o cupom ATACADAO30 e ganhe R$30 off em compras acima de R$150  ou  use o cupom ATACADAO20 e ganhe R$20 off em compras acima de R$200'
                    },
                    {
                        pergunta: "Existe compra mínima?",
                        resposta: "R$ 150,00 OU R$ 200,00 depende do cupom a ser aplicado."
                    },
                    {
                        pergunta: "Posso utilizar o cupom em todas as categorias?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "O frete está incluso?",
                        resposta: "Não"
                    },
                    {
                        pergunta: "Posso utilizar o desconto mais de uma vez?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "O cupom não está funcionando, como proceder?",
                        resposta: "Utilize o chat na pagina do parceiro https://www.evino.com.br ou pelo SAC (11)4200-4999"
                    },
                ]
            },
            {
                nome: "Pagamento",
                perguntas: [
                    {
                        pergunta: "Só posso pagar com o cartão Atacadão?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "Posso parcelar o pagamento?",
                        resposta: "Verificar as condiçoes no carrinho"
                    },
                ]
            },
        ]
    },
    {
        empresa: "Gocase",
        categorias: [
            {
                nome: "Cadastro",
                perguntas: [
                    {
                        pergunta: "O cliente precisa realizar algum cadastro?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "Onde o cadastro deve ser realizado?",
                        resposta: "No site do parceiro: https://www.gocase.com.br"
                    },
                ]
            },
            {
                nome: "Desconto",
                perguntas: [
                    {
                        pergunta: "Como faço para aplicar o desconto?",
                        resposta: "Use o cupom <b>ATACADAO10</b> e ganhe 10% off em todo o site."
                    },
                    {
                        pergunta: "Existe compra mínima?",
                        resposta: "Não"
                    },
                    {
                        pergunta: "Posso utilizar o cupom em todas as categorias?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "O frete está incluso?",
                        resposta: "Não"
                    },
                    {
                        pergunta: "Posso utilizar o desconto mais de uma vez?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "O cupom não está funcionando, como proceder?",
                        resposta: "Acesso o suporte da GoCase: https://suporte.gocase.com.br/hc/pt-br"
                    },
                ]
            },
            {
                nome: "Pagamento",
                perguntas: [
                    {
                        pergunta: "Só posso pagar com o cartão Atacadão?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "Posso parcelar o pagamento?",
                        resposta: "Verificar as condiçoes no carrinho"
                    },
                ]
            },
        ]
    },
    {
        empresa: "Unidas Aluguel de carros",
        categorias: [
            {
                nome: "Cadastro",
                perguntas: [
                    {
                        pergunta: "O cliente precisa realizar algum cadastro?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "Onde o cadastro deve ser realizado?",
                        resposta: "No site do parceiro: https://www.unidas.com.br/parceiro/ParceriaCartaoatacadao"
                    },
                ]
            },
            {
                nome: "Desconto",
                perguntas: [
                    {
                        pergunta: "Como faço para aplicar o desconto?",
                        resposta: "O desconto será aplicado automáticamente no carrinho. O percentual varia de acordo com a campanha vigente."
                    },
                    {
                        pergunta: "Existe compra mínima?",
                        resposta: "Não"
                    },
                    {
                        pergunta: "Posso utilizar o cupom em todas as categorias?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "O frete está incluso?",
                        resposta: "Não"
                    },
                    {
                        pergunta: "Posso utilizar o desconto mais de uma vez?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "O cupom não está funcionando, como proceder?",
                        resposta: "Utilize Serviço de Atendimento ao Cliente da Unidas: <b>0800 771 5158</b>"
                    },
                ]
            },
            {
                nome: "Pagamento",
                perguntas: [
                    {
                        pergunta: "Só posso pagar com o cartão Atacadão?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "Posso parcelar o pagamento?",
                        resposta: "Verificar as condiçoes no carrinho"
                    },
                ]
            },

        ]
    },
    {
        empresa: "Maria Brasileira",
        categorias: [
            {
                nome: "Cadastro",
                perguntas: [
                    {
                        pergunta: "O cliente precisa realizar algum cadastro?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "Onde o cadastro deve ser realizado?",
                        resposta: "No site do parceiro: https://mariabrasileira.com.br"
                    },
                ]
            },
            {
                nome: "Desconto",
                perguntas: [
                    {
                        pergunta: "Como faço para aplicar o desconto?",
                        resposta: "Ganhe R$15 OFF na contratação de qualquer serviço de limpeza ou passadeira. Desconto será aplicado após inserir os dados do Cartão Atacadão."
                    },
                    {
                        pergunta: "Existe compra mínima?",
                        resposta: "Não"
                    },
                    {
                        pergunta: "Posso utilizar o cupom em todas as categorias?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "O frete está incluso?",
                        resposta: "Não"
                    },
                    {
                        pergunta: "Posso utilizar o desconto mais de uma vez?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "O cupom não está funcionando, como proceder?",
                        resposta: "Utilize o suporte a dúvidas: https://mariabrasileira.com.br/duvidas"
                    },
                ]
            },
            {
                nome: "Pagamento",
                perguntas: [
                    {
                        pergunta: "Só posso pagar com o cartão Atacadão?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "Posso parcelar o pagamento?",
                        resposta: "Verificar as condiçoes no carrinho"
                    },
                ]
            },

        ]
    },
    {
        empresa: "Unidas Livre",
        categorias: [
            {
                nome: "Cadastro",
                perguntas: [
                    {
                        pergunta: "O cliente precisa realizar algum cadastro?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "Onde o cadastro deve ser realizado?",
                        resposta: "No site do parceiro: https://www.vemserlivre.com.br/parceria/cartaoatacadao"
                    },
                ]
            },
            {
                nome: "Desconto",
                perguntas: [
                    {
                        pergunta: "Como faço para aplicar o desconto?",
                        resposta: "30% OFF nas 8 primeiras parcelas no plano de 48 meses de um carro por assinatura. Desconto aplicado automáticamente no carrinho."
                    },
                    {
                        pergunta: "Existe compra mínima?",
                        resposta: "Sim, plano de 48 meses"
                    },
                    {
                        pergunta: "Posso utilizar o cupom em todas as categorias?",
                        resposta: "Somente no plano de 48 meses"
                    },
                    {
                        pergunta: "O frete está incluso?",
                        resposta: "Não"
                    },
                    {
                        pergunta: "Posso utilizar o desconto mais de uma vez?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "O cupom não está funcionando, como proceder?",
                        resposta: "Utilize o suporte a dúvidas: https://www.vemserlivre.com.br/parceria/cartaoatacadao"
                    },
                ]
            },
            {
                nome: "Pagamento",
                perguntas: [
                    {
                        pergunta: "Só posso pagar com o cartão Atacadão?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "Posso parcelar o pagamento?",
                        resposta: "Verificar as condiçoes no carrinho"
                    },
                ]
            },

        ]
    },
    {
        empresa: "Cacau Show",
        categorias: [
            {
                nome: "Cadastro",
                perguntas: [
                    {
                        pergunta: "O cliente precisa realizar algum cadastro?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "Onde o cadastro deve ser realizado?",
                        resposta: "No site do parceiro: https://www.cacaushow.com.br"
                    },
                ]
            },
            {
                nome: "Desconto",
                perguntas: [
                    {
                        pergunta: "Como faço para aplicar o desconto?",
                        resposta: "Use o cupom ATACADAO10 e ganhe 10% de desconto nas compras online acima de R$99."
                    },
                    {
                        pergunta: "Existe compra mínima?",
                        resposta: "Sim, R$ 99,00"
                    },
                    {
                        pergunta: "Posso utilizar o cupom em todas as categorias?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "O frete está incluso?",
                        resposta: "Não"
                    },
                    {
                        pergunta: "Posso utilizar o desconto mais de uma vez?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "O cupom não está funcionando, como proceder?",
                        resposta: "Utilize o suporte on line: https://lovers.cacaushow.com.br/ajuda/cacaulovers%23atendimento"
                    },
                ]
            },
            {
                nome: "Pagamento",
                perguntas: [
                    {
                        pergunta: "Só posso pagar com o cartão Atacadão?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "Posso parcelar o pagamento?",
                        resposta: "Verificar as condiçoes no carrinho"
                    },
                ]
            },

        ]
    },
    {
        empresa: "Doutor Consulta",
        categorias: [
            {
                nome: "Cadastro",
                perguntas: [
                    {
                        pergunta: "O cliente precisa realizar algum cadastro?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "Onde o cadastro deve ser realizado?",
                        resposta: "No site do parceiro: https://yalo.com.br/familiaatacadao"
                    },
                ]
            },
            {
                nome: "Desconto",
                perguntas: [
                    {
                        pergunta: "Como faço para aplicar o desconto?",
                        resposta: "Ganhe 10% off na assinatura do dr.consulta, o Yalo Família. Desconto já aplicado no carrinho."
                    },
                    {
                        pergunta: "Existe compra mínima?",
                        resposta: "Não"
                    },
                    {
                        pergunta: "Posso utilizar o cupom em todas as categorias?",
                        resposta: "Não, somente no plano Yalo Família."
                    },
                    {
                        pergunta: "O frete está incluso?",
                        resposta: "Não"
                    },
                    {
                        pergunta: "Posso utilizar o desconto mais de uma vez?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "O cupom não está funcionando, como proceder?",
                        resposta: "FALE CONOSCO: contato@yalo.com.br | 0800 591 0697"
                    },
                ]
            },
            {
                nome: "Pagamento",
                perguntas: [
                    {
                        pergunta: "Só posso pagar com o cartão Atacadão?",
                        resposta: "Sim"
                    },
                    {
                        pergunta: "Posso parcelar o pagamento?",
                        resposta: "Verificar as condiçoes no carrinho"
                    },
                ]
            },

        ]
    },

]